import { Accessor, ReqX } from "IZOX/STATIC";

class Register {

  static async Reigster(formValue){
    return await ReqX.SendBE("/Web/PublicUser/Register", formValue);
  }
  
  static async Apply(formValue){
    let userType = Accessor.Get(formValue, "userType");
    let url = null;
    switch(userType){
      case "Agent": url = "/Web/User/ApplyAgent"; break;
      case "DCustomer": url = "/Web/User/ApplyDC"; break;
      default: return {
        Success: false,
        payload: {
          EN: "Type not available",
          TC: "沒有該種類申請"
        }
      };
    }
    return await ReqX.SendBE(url, formValue);
  }

}

export default Register;